import {Button, Form, message, Tabs} from "antd";
import React from "react";
import {JobScope} from "../tabs/JobScope";
import {Disposal} from "../tabs/Disposal";
import {Labor} from "../tabs/Labor";
import {ProposalServicePost, ProposalServiceUpdate} from "../../../../../models/crm/service";
import {Equip} from "../tabs/Equip";
import {Material} from "../tabs/Material";
import {Rental} from "../tabs/Rental";
import {SubContractor} from "../tabs/SubContractor";
import {HeavyEquip} from "../tabs/HeavyEquip";

const TabPane = Tabs.TabPane;

class AddProposalServicesTabs extends React.Component {
    state = {
        loading: false,
        created: 0
    };

    submitProposalServiceForm = () => {
        const {created} = this.state;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({loading: true});
                values['proposal'] = this.props.proposal.id;
                created ?
                    ProposalServiceUpdate(created, values)
                        .then(response => {
                            message.success("Updated Details");
                            this.setState({loading: false, created: response.id});
                            this.props.onNext()
                        })
                    :
                    ProposalServicePost(values)
                        .then(response => {
                            this.setState({loading: false, created: response.id});
                            this.props.onNext()
                        })
                        .catch(error => {
                            this.setState({loading: false});
                            console.log(error)

                        })
            }
            else
                message.error("Please fill all tabs data")
        })
    };
    checkCompleteData=(field)=>{
        const value = this.props.form.getFieldValue(field);
        if(value){
            if(value.constructor === Number){
                return "complete-tab"
            }
            if(value.constructor === Array){
                if(value.length > 0)
                    return "complete-tab"
            }
        }
    };

     hasErrors() {
        const {getFieldsValue} = this.props.form;
        const values = getFieldsValue(['job_scope', 'heavy_equipment']);
        const fields = Object.keys(values);
        return fields.some(field => !values[field]);
    }

    render() {
        const {loading} = this.state;
        const {getFieldDecorator} = this.props.form;
        return (
            <React.Fragment>
                <div className="work-perform-collapse">
                    <div className="row">
                        <div className="col-12 tab-status create-services-tabs">
                            <Tabs animated={false} defaultActiveKey="1">
                                <TabPane tab={<span className={this.checkCompleteData('job_scope')}>Job Scope</span>} key="1">
                                    {getFieldDecorator('job_scope', {
                                        rules: [{required: true, message: 'Please enter job scope'}],
                                    })(<JobScope />)}
                                </TabPane>
                                 <TabPane tab={<span className={this.checkCompleteData('labor')}>Labor</span>} key="5">
                                     {getFieldDecorator('labor', {
                                    })(<Labor  />)}
                                </TabPane>
                                <TabPane tab={<span className={this.checkCompleteData('heavy_equipment')}>Heavy Equip/Truck</span>} key="2">
                                    {getFieldDecorator('heavy_equipment', {
                                        rules: [{required: true, message: 'Please enter heavy equipment'}],
                                    })(<HeavyEquip  />)}
                                </TabPane>

                                <TabPane tab={<span className={this.checkCompleteData('equip')}>Equipment</span>} key="6">
                                     {getFieldDecorator('equip', {
                                    })(<Equip  />)}
                                </TabPane>

                                <TabPane tab={<span className={this.checkCompleteData('material')}>Materials</span>} key="7">
                                     {getFieldDecorator('material', {
                                    })(<Material  />)}
                                </TabPane>
                                <TabPane tab={<span className={this.checkCompleteData('disposal')}>Disposal</span>} key="3">
                                    {getFieldDecorator('disposal', {
                                    })(<Disposal  />)}
                                </TabPane>
                                <TabPane tab={<span className={this.checkCompleteData('sub_contract')}>Sub Contractor</span>} key="9">
                                     {getFieldDecorator('sub_contract', {
                                    })(<SubContractor  />)}
                                </TabPane>
                                <TabPane tab={<span className={this.checkCompleteData('rental')}>Rental</span>} key="8">
                                     {getFieldDecorator('rental', {
                                    })(<Rental  />)}
                                </TabPane>

                            </Tabs>
                        </div>
                    </div>
                </div>
                <div className="row step-footer ">
                    <div className="col-12 steps-action text-right">
                        <Button  disabled={this.hasErrors()} className="nxtPrev-btn" loading={loading} type="primary"
                                onClick={this.submitProposalServiceForm}>Next</Button>
                        <Button className="back-btn"
                                onClick={this.props.onBack}>Previous</Button>
                    </div>
                </div>

            </React.Fragment>
        )
    }
}

export const AddProposalServices = Form.create()(AddProposalServicesTabs);



// WEBPACK FOOTER //
// ./src/pages/crm/proposals/popups/add_proposal_steps/AddProposalServicesTabs.jsx